// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import AutoimportController from "./autoimport_controller.js"
application.register("autoimport", AutoimportController)

import BookingSheetController from "./booking_sheet_controller.js"
application.register("booking-sheet", BookingSheetController)

import BookingsController from "./bookings_controller.js"
application.register("bookings", BookingsController)

import DashboardController from "./dashboard_controller.js"
application.register("dashboard", DashboardController)

import MenuController from "./menu_controller.js"
application.register("menu", MenuController)

import PanelController from "./panel_controller.js"
application.register("panel", PanelController)

import StripeController from "./stripe_controller.js"
application.register("stripe", StripeController)
